import BossModel from "@/models/BossModel";
import Customer from '@/models/Customer/Customer';
import AddressType from '@/models/AddressType/AddressType';
import City from '@/models/City/City';
import Province from '@/models/Province/Province';
import Country from '@/models/Country/Country';

export default class Address extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/address';

    /**
     *
     * @type {string}
     */
    static entity = 'customerAddresses';

    static fields() {
		return {
			id: this.attr(null),
			customer_id: this.number(null).nullable(),
			address_type_id: this.number(1).nullable(),
			company: this.attr(null),
			street: this.attr(null),
			number: this.attr(null),
			number_additional: this.attr(null),
			zip_code: this.attr(null),
			city_id: this.attr(null),
			province_id: this.number(null).nullable(),
			country_id: this.number(null).nullable(),
			is_default: this.boolean(true),
			sort_order: this.number(0).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
            customer: this.belongsTo(Customer, 'customer_id'),
            type: this.belongsTo(AddressType, 'address_type_id'),
            city: this.belongsTo(City, 'city_id'),
            province: this.belongsTo(Province, 'province_id'),
            country: this.belongsTo(Country, 'country_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Customer() {
        return this.getRelated('customer');
    }

    /**
     *
     * @returns {boolean|*}
     */
    AddressType() {
        return this.getRelated('type');
    }

    /**
     *
     * @returns {boolean|*}
     */
    City() {
        return this.getRelated('city');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Province() {
        return this.getRelated('province');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Country() {
        return this.getRelated('country');
    }
}
